<template>
  <div id="print1">
      <vs-progress :percent="viewpercentage" color="success">success</vs-progress><br>
       <h6>Work Progress {{viewpercentage}}% {{viewwork.iscomplete}}</h6><br>
        <vs-row  id="center">
          <h6>{{viewwork.detail}} #<a class="font-weight-bold"> {{viewwork.id}}</a></h6>
          <vs-spacer />
          <vs-button  icon="share" id="btnShare"  color="rgba(9, 30, 66, 0.04)" type="filled"><h6>Share</h6></vs-button>
        </vs-row>
        <vs-button  color="danger" style="border-radius: 20px;" size="sm" @click="printmodal()" type="filled">print</vs-button>
        <vs-row class="mt-3" id="center">
        
         <h6 id="center" ><vs-tooltip text="Tooltip position Top" position="top" > <span id="allIcon" class="material-icons mr-1">
            grid_view
          </span>  </vs-tooltip> Asset : N/A</h6>
           <h6 class="ml-2" id="center" ><vs-tooltip text="Who this Task is assigned to" position="top" > <span id="allIcon" class="material-icons mr-1">
            person
          </span>  </vs-tooltip> person</h6>
           <h6 class="ml-2" id="center" ><vs-tooltip text="The Due Date of this Task" position="top" > <span id="allIcon" class="material-icons mr-1">
            date_range
          </span>  </vs-tooltip> {{viewwork.duedate}}</h6>
          <h6  v-if="viewwork.iscomplete=='Complete'" class="ml-2" style="color: #32c040;" id="center" ><vs-tooltip text="The Due Date of this Task" position="top" > <span id="allIcon" class="material-icons mr-1">
            done
          </span>  </vs-tooltip> {{viewwork.iscomplete}}</h6>
           <h6 v-if="viewwork.iscomplete=='Upcoming (Late) (Overdue)'" class="ml-2" style="color: #ff911e;" id="center" ><vs-tooltip text="The Due Date of this Task" position="top" > <span id="allIcon" class="material-icons mr-1">
            assignment_late
          </span>  </vs-tooltip> {{viewwork.iscomplete}}</h6>
       
        </vs-row>
        <h6 class="mt-4">  Started by : {{viewwork.name}}</h6>
        <h6 class="mt-2">  Created Date : {{viewwork.timestamp}}</h6>
        <h6 class="mt-2">   Last edited : {{viewwork.editdate}}</h6>
        <h6 class="mt-2">    Status: {{viewwork.iscomplete}}</h6>
        <vs-row class="mt-4" id="center">
       <h6 class="font-weight-bold">Instructions: </h6>
      <vs-spacer />
       <!-- <vs-button  icon="share" id="btnShare"   type="filled"><h6>Share</h6></vs-button> -->
      </vs-row>
      <br>
      
     
       <h6 class=" mb-2" >Completion Notes :</h6>
       <vs-textarea v-model="textarea" />
       <vs-button  icon="done" size="small" @click="complete" class="rounded-pill" color="success" type="filled">Complete</vs-button>
      <!-- <FormRenderer :form-configuration="formData" v-model="formInputData"/> -->
       
  </div>
</template>

<script>
import {FormRenderer} from 'v-form-builder';
export default {
  name: 'WO',
  components: {
    FormRenderer,
  },
  props: [
    'viewwork',
  ],
  computed: {
  },
  data: () => ({
    role: '',
    nameValue:'',
    viewpercentage: 0,
    formData: '',
    activePrompt: false,
  }),
  methods: {
    printmodal(){
      const modal = document.getElementById("print1")
      const cloned = modal.cloneNode(true)
      let section = document.getElementById("print")

      if (!section) {
        section  = document.createElement("div")
        section.id = "print"
        document.body.appendChild(section)
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();

    },
  
    view() {
    },
    complete(){
      console.log(this.viewwork.id, this.viewwork.username)
      const body = {
        id: this.viewwork.id,
        username : this.viewwork.username,
         status: 'true'
      }
      this.$API.post('updateworkstatus',body).then((result)=>{
        if(result.status == 200) this.$vs.notify({title:'Work Order Updated',text:'Your work order has been updated',color: 'primary',position:'top-center'})
        setTimeout(()=> { 
          location.reload(1); 
        }, 1000);
      }).catch((err)=>{
        if(err.response.status == 500) this.$vs.notify({title:'Invalid',text:'Please try again',color: 'warning',position:'top-center'})
      })
      console.log(body)
    }
  },
  mounted() {
    this.role = this.$session.get('role')
    console.log('mounting table')
    this.viewpercentage = 0
    var maxitem = 0
    var nullitem = 0
    var item = this.viewwork
    console.log(item)
    this.formData = item.form
    this.activePrompt = true
    setTimeout(() => {
      this.formInputData = item.inputdata
      console.log(this.formInputData)
      if(item.inputdata) {
        Object.keys(item.inputdata).forEach(element => {
          maxitem += 1
          if(item.inputdata[element] == null || item.inputdata[element] == 0 || item.inputdata[element] == '') {
            nullitem += 1
          }
        });
        this.viewpercentage = ([(maxitem-nullitem)/maxitem]*100).toFixed(2)
      }
    }, 200);
  }
}
</script>

<style scoped>
.inputData {
    color: inherit;
    position: relative;
    padding: .4rem;
    border-radius: 5px;
    border: 1px solid rgba(0,0,0,.2);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
    box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    
}
#btnShare{
  color: #111111; 
  border-radius: 20px;
    display: inline-block;
    -webkit-transition: all .25s ease;
    transition: all .25s ease;
    
}
#center{
   text-align: center;
}
#allIcon{
  font-size: 16px;
}
.modal-open .modal {
padding-right: 0px;
}
.p-0{
  padding: 0;
}
</style>